var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoListedProperty = function SvgNoListedProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 382,
    height: 304,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M223.676 111.195c-23.578.141-47.521-.957-69.917-7.175s-42.204-17.95-60.21-31.652c-11.79-8.92-22.51-16.01-37.815-14.94a69.78 69.78 0 0 0-40.825 15.925c-19.47 17.05-16.516 48.562-8.75 70.733 11.704 33.397 47.324 56.581 77.57 71.689 34.973 17.473 73.378 27.63 111.896 33.454 33.762 5.12 77.119 8.863 106.352-13.196 26.87-20.229 34.242-66.485 27.658-97.715a38.46 38.46 0 0 0-13.815-23.409c-18.879-13.787-47.015-4.586-68.229-4.108-7.737.169-15.868.366-23.915.394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.392,
    d: "M108.712 2v12.098M102.664 8.049h12.098M338.243 243.151v12.098M332.195 249.2h12.099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M17.298 190.903a2.757 2.757 0 1 0 .001-5.514 2.757 2.757 0 0 0 0 5.514M252.065 14.492a2.757 2.757 0 1 0 0-5.514 2.757 2.757 0 0 0 0 5.514"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M175.649 303.924c57.027 0 103.258-2.872 103.258-6.415s-46.231-6.415-103.258-6.415c-57.028 0-103.258 2.872-103.258 6.415s46.23 6.415 103.258 6.415"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "M96.109 34.863h149.963a14.066 14.066 0 0 1 14.068 14.068V227.34a14.067 14.067 0 0 1-14.068 14.067H76.892a14.07 14.07 0 0 1-14.068-14.067V68.485z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M259.463 121.802H104.829v121.321h154.634z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "M62.824 68.485h27.264a6.05 6.05 0 0 0 6.02-6.049V34.863zM258.704 83.06H105.758c-5.951 0-10.776 4.824-10.776 10.775v32.722c0 5.952 4.825 10.776 10.776 10.776h152.946c5.951 0 10.776-4.824 10.776-10.776V93.835c0-5.95-4.825-10.775-10.776-10.775"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M124.695 119.664a9.398 9.398 0 1 0-.001-18.797 9.398 9.398 0 0 0 .001 18.797M154.237 119.664c5.19 0 9.397-4.208 9.397-9.398a9.397 9.397 0 0 0-9.397-9.397 9.397 9.397 0 0 0-9.397 9.397c0 5.19 4.207 9.398 9.397 9.398M183.749 119.664c5.19 0 9.397-4.208 9.397-9.398a9.397 9.397 0 0 0-9.397-9.397 9.397 9.397 0 0 0-9.397 9.397c0 5.19 4.207 9.398 9.397 9.398"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "M258.704 143.213H105.758c-5.951 0-10.776 4.824-10.776 10.776v32.722c0 5.951 4.825 10.776 10.776 10.776h152.946c5.951 0 10.776-4.825 10.776-10.776v-32.722c0-5.952-4.825-10.776-10.776-10.776"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M124.695 179.846a9.398 9.398 0 1 0-.001-18.793 9.398 9.398 0 0 0 .001 18.793M154.237 179.846a9.397 9.397 0 0 0 9.397-9.397c0-5.19-4.207-9.398-9.397-9.398s-9.397 4.208-9.397 9.398a9.397 9.397 0 0 0 9.397 9.397M183.749 179.846a9.397 9.397 0 0 0 9.397-9.397c0-5.19-4.207-9.398-9.397-9.398s-9.397 4.208-9.397 9.398a9.397 9.397 0 0 0 9.397 9.397"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "M258.704 203.396H105.758c-5.951 0-10.776 4.824-10.776 10.775v32.722c0 5.952 4.825 10.776 10.776 10.776h152.946c5.951 0 10.776-4.824 10.776-10.776v-32.722c0-5.951-4.825-10.775-10.776-10.775"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M124.695 240.001a9.398 9.398 0 1 0-.001-18.797 9.398 9.398 0 0 0 .001 18.797M154.237 240.001c5.19 0 9.397-4.208 9.397-9.398a9.397 9.397 0 0 0-9.397-9.397 9.397 9.397 0 0 0-9.397 9.397c0 5.19 4.207 9.398 9.397 9.398M183.749 240.001c5.19 0 9.397-4.208 9.397-9.398a9.397 9.397 0 0 0-9.397-9.397 9.397 9.397 0 0 0-9.397 9.397c0 5.19 4.207 9.398 9.397 9.398"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "M272.546 151.597c32.212 0 58.325-26.113 58.325-58.325s-26.113-58.325-58.325-58.325-58.325 26.113-58.325 58.325 26.113 58.325 58.325 58.325"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "m313.962 135.588 15.531 15.531"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.814,
    d: "m327.758 143.579-4.822 5.044a5.684 5.684 0 0 0 .181 8.036l41.896 40.05a5.684 5.684 0 0 0 8.036-.181l4.821-5.043a5.684 5.684 0 0 0-.181-8.036l-41.896-40.05a5.684 5.684 0 0 0-8.035.18"
  })));
};
export default SvgNoListedProperty;